<style lang="scss" src='./Agent.scss' scoped></style>
<template src="./Agent.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getAgents,
  postAgents,
  editAgents
} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Agent',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      agentsAvailable: [],
      newActive: false,
      editAgent: null,
      agentName: null,
      loading: false,
    };
  },
  computed: {
    orderedAgents() {
      if (this.agentsAvailable && this.agentsAvailable.length > 0) {
        let getName = this.getLabel;
        return this.agentsAvailable.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

  methods: {
    getLabel(item) {
      return item.agent_name;
    },

    showNewModal() {
      this.newActive = true;
      this.agentName = null;
      this.$bvModal.show('modal-add-agent')
    },

    showEditModal(item) {
      this.loading = false;
      this.editAgent = item;
      this.agentName = item.agent_name;
      this.newActive = false;
      this.$bvModal.show('modal-add-agent');
    },
    
    async saveAgent(){
      this.loading = true;
      if(this.agentName){

        let data = {
          name: this.agentName,
        };

        if(this.newActive) {

          postAgents(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-agent');
          })
        } else {
          editAgents(data, this.editAgent.agent_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-agent');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadAvailableAgents();
    },

    loadAvailableAgents() {
      getAgents().then((resp) => {
        if (resp.agents && resp.agents.length) {
          this.agentsAvailable = resp.agents.map(agent => ({...agent, selected: false}));
        } else {
          this.agentsAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Agents");
      this.$analytics.logEvent("web_settings_agents");
    }

    this.loadData();
  },
};

</script>
